import { createSelector } from 'reselect';
import property from 'lodash/property';
import getDefaultShippingConfiguration from './getDefaultShippingConfiguration';

export default createSelector(
  getDefaultShippingConfiguration,
  property('key'),
);
